export default "__VITE_ASSET__DuiKv9M3__"